export {
  default,
  default as useInsightsLicenseAction,
} from "./useInsightsLicenseAction";
